import React, { useEffect, useRef, useState } from "react";
import { useObjectStore } from "../zustand/objects";
import { MBX_DARK_BACKGROUND_FILL, projectStyle } from "../styleFile";
import { getViewportSceneTheme } from "../utils/viewportCanvasDefaults";
import { ScreenshotStoryboardPOV } from "./Screenshot";

/**
 * Live storyboard scene thumb — matches `ScreenshotForProjectsPage` / editor theme (sky, floor, clear color).
 * Lazy-mounted near viewport like template modal grids to limit concurrent WebGL contexts.
 */
export function LazyStoryboardSceneThumb({ sceneKey, previewKey, objectsAreLoaded, artboards }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);

  useEffect(() => {
    setVisible(false);
  }, [previewKey]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setVisible(true);
      },
      { root: null, rootMargin: "140px 0px", threshold: 0 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [previewKey]);

  const thumbBg =
    viewportThemeOverride === "dark"
      ? MBX_DARK_BACKGROUND_FILL
      : getViewportSceneTheme("light").background;

  const hasScene = artboards && artboards[sceneKey];

  return (
    <div
      ref={ref}
      style={{
        ...projectStyle.container.projectScreenshotContainer,
        position: "absolute",
        inset: 0,
        minHeight: 0,
        backgroundColor: thumbBg,
      }}
    >
      {visible && objectsAreLoaded && hasScene ? (
        <ScreenshotStoryboardPOV artboard={sceneKey} />
      ) : null}
    </div>
  );
}
